export default __webpack_public_path__ + "locales/pt/Settings.json?hash=fa8bbd4275e7269e1c56ff32f0ee1bab";